import React, { Fragment, type HTMLAttributes } from 'react';

import { Spacer, Wrapper } from './Styles';

export interface SpacedItemsProps extends HTMLAttributes<HTMLDivElement> {
  singleChildAlignment?: 'left' | 'right';
  alignVertically?: 'start' | 'center' | 'end';
  gap?: number;
  forwardRef?: React.MutableRefObject<HTMLDivElement | null> | React.ForwardedRef<HTMLDivElement>;
}

export const SpacedItems: React.FC<SpacedItemsProps> = ({
  singleChildAlignment = 'left',
  gap = 0,
  alignVertically = 'start',
  children,
  forwardRef,
  ...props
}) => {
  const childrenList = React.Children.toArray(children).filter((child) => child !== null);

  return (
    <Wrapper
      ref={forwardRef}
      $gap={gap}
      $alignRight={singleChildAlignment === 'right'}
      $alignVertically={alignVertically}
      {...props}
    >
      {childrenList.map((child, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={i}>
          {i > 0 && <Spacer />}
          {child}
        </Fragment>
      ))}
    </Wrapper>
  );
};
